const compatModules = {};import * as Mod1 from "./discourse/components/waze-header-chat-icon";
compatModules["discourse/components/waze-header-chat-icon"] = Mod1;

export * as discourse$components$waze__header__chat__icon$$__module from "./discourse/components/waze-header-chat-icon";
export {
default as discourse$components$waze__header__chat__icon$$default
} from "./discourse/components/waze-header-chat-icon";
import * as Mod2 from "./discourse/connectors/user-card-below-message-button/user-card-waze-chat-button.gjs";
compatModules["discourse/connectors/user-card-below-message-button/user-card-waze-chat-button"] = Mod2;

export * as discourse$connectors$user__card__below__message__button$user__card__waze__chat__button$$__module from "./discourse/connectors/user-card-below-message-button/user-card-waze-chat-button.gjs";
export {
default as discourse$connectors$user__card__below__message__button$user__card__waze__chat__button$$default
} from "./discourse/connectors/user-card-below-message-button/user-card-waze-chat-button.gjs";
import * as Mod3 from "./discourse/connectors/user-profile-controls/user-profile-waze-chat-button.gjs";
compatModules["discourse/connectors/user-profile-controls/user-profile-waze-chat-button"] = Mod3;

export * as discourse$connectors$user__profile__controls$user__profile__waze__chat__button$$__module from "./discourse/connectors/user-profile-controls/user-profile-waze-chat-button.gjs";
export {
default as discourse$connectors$user__profile__controls$user__profile__waze__chat__button$$default
} from "./discourse/connectors/user-profile-controls/user-profile-waze-chat-button.gjs";
import * as Mod4 from "./discourse/initializers/waze-chat";
compatModules["discourse/initializers/waze-chat"] = Mod4;

export * as discourse$initializers$waze__chat$$__module from "./discourse/initializers/waze-chat";
export {
default as discourse$initializers$waze__chat$$default
} from "./discourse/initializers/waze-chat";
export default compatModules;
